import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Icon, MaybeWrap, UniversalLink } from '@plone/volto/components';
import { Input, Button, Message } from 'semantic-ui-react';
import cx from 'classnames';
import navTreeSVG from '@plone/volto/icons/nav.svg';
import imageBlockSVG from '@plone/volto/components/manage/Blocks/Image/block-image.svg';
import config from '@plone/volto/registry';
import { ConditionalLink } from '@plone/volto/components';

const messages = defineMessages({
  PleaseChooseContent: {
    id: 'Please choose an existing content as source for this element',
    defaultMessage:
      'Please choose an existing content as source for this element',
  },
  moreInfo: {
    id: 'moreInfo',
    defaultMessage: 'More info',
  },
  source: {
    id: 'Source',
    defaultMessage: 'Source',
  },
});

const DefaultImage = (props) => <img {...props} alt={props.alt || ''} />;

const SliderBody = ({
  index,
  onChangeBlock,
  block,
  data,
  dataBlock,
  isEditMode,
  openObjectBrowser,
}) => {
  const intl = useIntl();
  const href = data.href?.[0];

  const Image = config.getComponent('Image').component || DefaultImage;

  const handleClick = () => {
    openObjectBrowser({
      onSelectItem: (url, document) => {
        dataBlock.slides[index].title = document.Title;
        dataBlock.slides[index].description = document.Description;
        dataBlock.slides[index].href = [
          {
            '@id': document['@id'],
            Title: document.Title,
            Description: document.Description,
            title: document.Title,
            image_field: document.image_field,
            hasPreviewImage: document.hasPreviewImage,
          },
        ];
        onChangeBlock(block, dataBlock);
      },
      mode: 'link',
    });
  };

  return (
    <div
      className={cx('grid-teaser-item top', {
        'empty-slide': !href && isEditMode,
      })}
    >
      {(!href || !href.image_scales || !href?.image_scales?.image[0]) &&
        isEditMode && (
          <Message>
            <div className="grid-teaser-item default">
              <img src={imageBlockSVG} alt="" />
              <p>{intl.formatMessage(messages.PleaseChooseContent)}</p>
              <div className="toolbar-inner">
                <Button.Group>
                  <Button onClick={handleClick} icon basic>
                    <Icon name={navTreeSVG} size="24px" />
                  </Button>
                </Button.Group>
                <Input
                  placeholder={`${intl.formatMessage(messages.source)}...`}
                  onClick={handleClick}
                  onFocus={(e) => e.target.blur()}
                />
              </div>
            </div>
          </Message>
        )}
      {href?.image_scales?.image?.[0] && (
        <div className="teaser-item top">
          <MaybeWrap
            condition={false}
            as={UniversalLink}
            href=""
            target={data.openLinkInNewTab ? '_blank' : null}
            tabIndex="-1"
          >
            <ConditionalLink
              item={data?.link_to?.[0]}
              condition={!isEditMode && !!data?.link_to?.length}
            >
              <div className="highlight-image-wrapper gradient">
                <Image
                  item={href}
                  alt={data['image_alt'] || 'Slider Image'}
                  sizes="(max-width: 1350px) 100vw, 1350px"
                  height="auto"
                />
              </div>
              <div
                className={`teaser-item-title fix-width-issue ${data.color && data.color}`}
              >
                <div className="title">
                  {data?.head_title && (
                    <span className="supertitle">{data?.head_title}</span>
                  )}
                  <h2>{data?.nav_title || data?.title}</h2>
                </div>
                <p>{data?.description}</p>
              </div>
            </ConditionalLink>
          </MaybeWrap>
        </div>
      )}
    </div>
  );
};

export default SliderBody;
